import React from "react";
import { ToastContainer } from "react-toastify";
import Head from "../Global/Head";
import Header from "../Global/Header";
import Stepper from "../main/createTableForm/Stepper";

const CreateTable = () => {
  return (
    <div>
      <ToastContainer />
      <Head />
      <Header />
      <Stepper />
    </div>
  );
};

export default CreateTable;
